"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentOutreach = void 0;
var DeploymentOutreach;
(function (DeploymentOutreach) {
    let method;
    (function (method) {
        method["MANUAL"] = "manual";
        method["AUTOMATIC"] = "automatic";
    })(method = DeploymentOutreach.method || (DeploymentOutreach.method = {}));
    let language;
    (function (language) {
        language["EN"] = "en";
        language["ES"] = "es";
        language["RU"] = "ru";
        language["DE"] = "de";
        language["FR"] = "fr";
        language["PT"] = "pt";
        language["KO"] = "ko";
        language["IT"] = "it";
        language["TR"] = "tr";
        language["PL"] = "pl";
        language["PT_BR"] = "pt-BR";
    })(language = DeploymentOutreach.language || (DeploymentOutreach.language = {}));
    let stage;
    (function (stage) {
        stage["INITIAL_INVITE"] = "initialInvite";
        stage["DIDNT_OPEN_OFFER_PAGE"] = "didntOpenOfferPage";
        stage["OPENED_OFFER_PAGE"] = "openedOfferPage";
        stage["ACCEPTED_OFFER"] = "acceptedOffer";
        stage["ACCEPTED_TERMS"] = "acceptedTerms";
        stage["FINISHED_RUNNING"] = "finishedRunning";
        stage["RUNNING"] = "running";
    })(stage = DeploymentOutreach.stage || (DeploymentOutreach.stage = {}));
    let target;
    (function (target) {
        target["DIRECT"] = "direct";
        target["AGENCY"] = "agency";
    })(target = DeploymentOutreach.target || (DeploymentOutreach.target = {}));
    let medium;
    (function (medium) {
        medium["EMAIL"] = "email";
        medium["DISCORD"] = "discord";
    })(medium = DeploymentOutreach.medium || (DeploymentOutreach.medium = {}));
})(DeploymentOutreach = exports.DeploymentOutreach || (exports.DeploymentOutreach = {}));
